import React from 'react';

//Material
import { Box, Grid, Typography } from '@mui/material';

//Components
import { LetsGoBtn } from '../../../components/Buttons';
import { useNavigate } from 'react-router-dom';
import Illustration1 from '../../../assets/StepsIcons.png';
import Illustration2 from '../../../assets/StepsIcons2.png';
import Illustration3 from '../../../assets/StepsIcons3.png';

export default function TariffsBlock() {
  const navigate = useNavigate();

  return (
    <Grid item xs={12} sx={{ mb: 5, position: 'relative' }} className="tariffsBlock-main">
      <Grid
        className="tariffsBlock-main-container"
        container
        spacing={0}
        sx={{
          width: '100%',
          margin: '0px !important',
          height: '100%',
          p: 0,
          justifyContent: 'center'
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            p: '0px !important',
            mb: 2
          }}
        >
          <Typography
            variant="h2"
            sx={{
              margin: '0px',
              wordBreak: 'break-word',
              fontFamily: 'FixelText-SemiBold !important',
              fontSize: { xs: '32px', sm: '40px' },
              textAlign: 'center',
              zIndex: 1,
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'column', md: 'row' }
              // maxWidth: 500
            }}
          >
            Покращуй досвід на платформі з
            <Typography
              variant="h2"
              sx={{
                fontFamily: 'FixelText-SemiBold !important',
                fontSize: { xs: '32px', sm: '40px' },
                color: '#60A5DF',
                zIndex: 2,
                ml: 1
              }}
            >
              {' Преміум! '}
            </Typography>
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontSize: '20px',
              textAlign: 'center',
              zIndex: 1,

              mt: 2,
              maxWidth: { xs: '99%', sm: '90%', lg: '60%' },
              fontFamily: 'FixelText-Medium'
            }}
          >
            Наші ексклюзивні інструменти та функції допоможуть вам забезпечити зростання вашого
            бізнесу. Більше переваг, більше результатів!
          </Typography>
          <LetsGoBtn
            className="service-card-btn"
            width={{ xs: '100%', sm: '230px' }}
            margin={{ xs: '30px auto', sm: '35px 0px 10px 24px' }}
            text="До тарифних планів"
            onClick={() => {
              navigate(`/ua/tariffs`);
            }}
          />
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={4}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            zIndex: 1,
            pr: { xs: '0px !important', sm: 2, md: 2, lg: 2 },

            pl: {
              xs: '0px !important',
              sm: '0px !important',
              md: '0px !important',
              lg: '0px !important'
            }
          }}
        >
          <Box
            sx={{
              maxWidth: '395px',
              height: '224px',
              background: 'white',
              borderRadius: '8px',
              boxShadow: '0px 0px 8px -3px rgba(0, 0, 0, 0.32)',
              p: '20px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'start',
              alignItems: 'left'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%'
              }}
            >
              <img alt={'illustration1'} src={Illustration1} />
              <Typography
                variant="p"
                sx={{
                  margin: '0px',
                  wordBreak: 'break-word',
                  fontFamily: 'FixelText-SemiBold !important',
                  fontSize: '20px',
                  color: '#60A5DF',
                  textAlign: 'center',
                  zIndex: 1
                  // maxWidth: 500
                }}
              >
                01
                <Typography
                  variant="p"
                  sx={{
                    fontFamily: 'FixelText-Regular !important',
                    fontSize: '18px',
                    zIndex: 2,
                    color: '#c7c4c4'
                  }}
                >
                  / 03
                </Typography>
              </Typography>
            </Box>

            <Typography
              variant="p"
              sx={{
                margin: '0px',
                wordBreak: 'break-word',
                fontFamily: 'FixelText-Medium !important',
                fontSize: '20px',
                color: 'black',
                textAlign: 'left',
                zIndex: 1,
                mt: 2
                // maxWidth: 500
              }}
            >
              Купівля преміум
            </Typography>
            <Typography
              variant="p"
              sx={{
                margin: '0px',
                wordBreak: 'break-word',
                fontFamily: 'FixelText-Regular !important',
                fontSize: '16px',
                color: '#7C7C7C',
                textAlign: 'left',
                zIndex: 1,
                mt: 2
                // maxWidth: 500
              }}
            >
              Розширюйте свої можливості з преміум-функціями. Легкий доступ до унікальних
              інструментів та переваг.
            </Typography>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={4}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            zIndex: 1,
            pr: { xs: '0px !important', sm: 2, md: 2, lg: 2 },
            pl: {
              xs: '0px !important',
              sm: '16px !important',
              md: '16px !important',
              lg: '16px !important'
            },
            pt: {
              xs: '16px !important',
              sm: '0px !important',
              md: '0px !important',
              lg: '0px !important'
            }
          }}
        >
          <Box
            sx={{
              maxWidth: '395px',
              height: '224px',
              background: 'white',
              borderRadius: '8px',
              boxShadow: '0px 0px 8px -3px rgba(0, 0, 0, 0.32)',
              p: '20px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'start',
              alignItems: 'left'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%'
              }}
            >
              <img alt={'illustration1'} src={Illustration2} />
              <Typography
                variant="p"
                sx={{
                  margin: '0px',
                  wordBreak: 'break-word',
                  fontFamily: 'FixelText-SemiBold !important',
                  fontSize: '20px',
                  color: '#60A5DF',
                  textAlign: 'center',
                  zIndex: 1
                  // maxWidth: 500
                }}
              >
                02
                <Typography
                  variant="p"
                  sx={{
                    fontFamily: 'FixelText-Regular !important',
                    fontSize: '18px',
                    zIndex: 2,
                    color: '#c7c4c4'
                  }}
                >
                  / 03
                </Typography>
              </Typography>
            </Box>

            <Typography
              variant="p"
              sx={{
                margin: '0px',
                wordBreak: 'break-word',
                fontFamily: 'FixelText-Medium !important',
                fontSize: '20px',
                color: 'black',
                textAlign: 'left',
                zIndex: 1,
                mt: 2
                // maxWidth: 500
              }}
            >
              Створення продукту
            </Typography>
            <Typography
              variant="p"
              sx={{
                margin: '0px',
                wordBreak: 'break-word',
                fontFamily: 'FixelText-Regular !important',
                fontSize: '16px',
                color: '#7C7C7C',
                textAlign: 'left',
                zIndex: 1,
                mt: 2
                // maxWidth: 500
              }}
            >
              Додавайте товари швидко та просто. Презентуйте свої ідеї мільйонам користувачів.
            </Typography>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={4}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            zIndex: 1,
            pr: { xs: '0px !important', sm: 2, md: 2, lg: 2 },
            pl: {
              xs: '0px !important',
              sm: '0px !important',
              md: '16px !important',
              lg: '16px !important'
            },
            pt: {
              xs: '16px !important',
              sm: '16px !important',
              md: '16px !important',
              lg: '0px !important'
            }
          }}
        >
          <Box
            sx={{
              maxWidth: '395px',
              height: '224px',
              background: 'white',
              borderRadius: '8px',
              boxShadow: '0px 0px 8px -3px rgba(0, 0, 0, 0.32)',
              p: '20px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'start',
              alignItems: 'left'
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%'
              }}
            >
              <img alt={'illustration1'} src={Illustration3} />
              <Typography
                variant="p"
                sx={{
                  margin: '0px',
                  wordBreak: 'break-word',
                  fontFamily: 'FixelText-SemiBold !important',
                  fontSize: '20px',
                  color: '#60A5DF',
                  textAlign: 'center',
                  zIndex: 1
                  // maxWidth: 500
                }}
              >
                03
                <Typography
                  variant="p"
                  sx={{
                    fontFamily: 'FixelText-Regular !important',
                    fontSize: '18px',
                    zIndex: 2,
                    color: '#c7c4c4'
                  }}
                >
                  / 03
                </Typography>
              </Typography>
            </Box>

            <Typography
              variant="p"
              sx={{
                margin: '0px',
                wordBreak: 'break-word',
                fontFamily: 'FixelText-Medium !important',
                fontSize: '20px',
                color: 'black',
                textAlign: 'left',
                zIndex: 1,
                mt: 2
                // maxWidth: 500
              }}
            >
              Отримання прибутку
            </Typography>
            <Typography
              variant="p"
              sx={{
                margin: '0px',
                wordBreak: 'break-word',
                fontFamily: 'FixelText-Regular !important',
                fontSize: '16px',
                color: '#7C7C7C',
                textAlign: 'left',
                zIndex: 1,
                mt: 2
                // maxWidth: 500
              }}
            >
              Слідкуйте за своїми доходами та отримуйте детальні звіти про прибутки для ефективного
              управління фінансами.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
}
